export default __webpack_public_path__ + "static/media/pic53.557cab54.JPG";